import { Crisp as CrispSDK } from 'crisp-sdk-web'
import { useEffect } from 'react'
import { crispWebsiteId, requestCrispHidden, syncCrispVisibility } from './crisp-visibility.js'

/**
 * Load Crisp, and show or hide its bubble. `show: false` holds a hide request for as long as the
 * caller is mounted; the bubble returns once no surface asks for it to be hidden.
 */
export const useCrisp = ({ show = true }: { show?: boolean } = {}) => {
  useEffect(() => {
    if (!crispWebsiteId) {
      return
    }
    // Already loaded?
    if (CrispSDK.isCrispInjected()) {
      return
    }

    /**
     * @note positioning etc. is configured at Crisp
     * @see https://app.crisp.chat/settings/account/interface/
     */
    CrispSDK.configure(crispWebsiteId, {/** Options here */})
  }, [])

  useEffect(() => {
    if (show) {
      syncCrispVisibility()
      return undefined
    }
    return requestCrispHidden()
  }, [show])

  return CrispSDK
}
